function RoutesFormController(stateService, toasterService, $uibModal) {
  const ctrl = this;

  ctrl.$onInit = async () => {
    // Init route object
    ctrl.route = {
      name: null,
      description: null,
      stations: [],
      variables: [],
    };
    // Set viewmode if selection object is present
    if (!ctrl.selection) {
      ctrl.newRoute = true;
      ctrl.viewMode = false;
    } else {
      ctrl.viewMode = true;
    }
    ctrl.filteredStations = [];
    ctrl.currentStations = [];
    ctrl.stationsTooltip = 'Add route variables to a station by expanding a row.';
    ctrl.workspaceId = stateService.getSelectedWorkspace().id;
    ctrl.loading = true;
    ctrl.stations = await stateService.getStations(ctrl.workspaceId);

    if (ctrl.selection) {
      addStationNames(ctrl.stations.stations, ctrl.selection.stations);
      ctrl.route = angular.copy(ctrl.selection);
      ctrl.viewStartStation = _.head(ctrl.route.stations);
      ctrl.viewEndStation = _.last(ctrl.route.stations);
      ctrl.currentStations = filterStations(ctrl.route.stations);
    }
    ctrl.loading = false;
    ctrl.routeMap = await stateService.getRouteMap(ctrl.workspaceId);
  };

  // Returns a filtered list with only stations that have variables
  const filterStations = stations => stations.filter(obj => obj.variables.length > 0);

  const addStationNames = (allStations, routeStations) => {
    routeStations.map(station => {
      let found = allStations.find(item => item.id === station.id);
      station.name = found.name;
    });
  };

  ctrl.resetRoute = () => {
    ctrl.route.name = null;
    ctrl.route.description = null;
    ctrl.route.stations = [];
    ctrl.startStation = null;
    ctrl.endStation = null;
  };

  ctrl.toggleEditMode = value => {
    if (value) {
      ctrl.viewMode = false;
    } else {
      ctrl.route = angular.copy(ctrl.selection);
      ctrl.viewMode = true;
    }
  };

  ctrl.startSelected = () => {
    // Reset selected end station and station list if user re-selects start station
    ctrl.endStation = null;
    ctrl.route.stations = [];
    ctrl.filteredStations = [];
    // Filter out stations that are invalid based on the chosen start station
    let keys = _.keys(ctrl.routeMap[ctrl.startStation.id]);
    _.each(keys, sId => {
      let foundStation = ctrl.stations.stations.find(obj => obj.id === parseInt(sId));
      if (foundStation) ctrl.filteredStations.push(foundStation);
    });
  };

  ctrl.endSelected = () => {
    // Reset stationlist if end station is re-selected
    ctrl.route.stations = [];
    // Build the stationlist
    let route = ctrl.routeMap[ctrl.startStation.id][ctrl.endStation.id];
    _.each(route, stationId => {
      let foundStation = ctrl.filteredStations.find(obj => obj.id === stationId);
      if (foundStation) {
        // Route editing only, check if there's saved stations with variables to copy over
        if (ctrl.currentStations.length > 0) {
          let found = ctrl.currentStations.find(item => item.id === foundStation.id);
          if (found) foundStation.variables = found.variables;
        } else {
          // Empty variables array because global station variables should not be copied over to route's station variables
          foundStation.variables = [];
        }
        ctrl.route.stations.push(foundStation);
      }
    });
    ctrl.route.name = `${ctrl.startStation.name} to ${ctrl.endStation.name}`;
  };

  ctrl.checkValidity = () => {
    return ctrl.route.stations.length === 0 || !ctrl.route.name || !ctrl.route.description;
  };

  ctrl.onSubmit = () => {
    if (ctrl.newRoute) {
      ctrl.route.stations = ctrl.route.stations.map(station => {
        return { id: station.id, variables: station.variables };
      });
      stateService.createRoute(ctrl.route, ctrl.workspaceId).then(
        function(response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          toasterService.success('toaster.pis-event', 'toaster.pis-new-route-successful');
        },
        function(e) {
          console.error(e);
        }
      );
    } else {
      ctrl.route.stations = ctrl.route.stations.map(station => {
        return { id: station.id, variables: station.variables };
      });
      stateService.editRoute(ctrl.workspaceId, ctrl.route.id, ctrl.route).then(
        function(response) {
          ctrl.onFormSubmit({
            $event: {
              mode: false,
            },
          });
          toasterService.success('toaster.pis-event', 'toaster.pis-edit-route-successful');
        },
        function(e) {
          console.error(e);
        }
      );
    }
  };

  ctrl.removeVariable = (index, station) => {
    station.variables.splice(index, 1);
  };

  ctrl.openVariableModal = station => {
    let modalInstance = $uibModal.open({
      component: 'variableModal',
      backdrop: 'static',
      windowClass: 'subSystemWindow',
      resolve: {
        workspaceId: () => ctrl.workspaceId,
        view: () => 'route'
      },
    });

    modalInstance.result.then(
      variableObject => {
        // User pressed 'Yes' in the modal.
        station.variables.push({ name: variableObject.name, value: variableObject.value });
      },
      () => {
        // User pressed 'Cancel' in the modal, do nothing.
      }
    );
  };
}

angular
  .module('pis-tool.module')
  .controller('RoutesFormController', RoutesFormController);
